<div class="row g-3">
  <div class="col-12">
    <div class="card shadow border-0" id="quick-stats">
      <div class="card-header fw-bold">
        <h6 class="card-title mb-0"><i class="bi bi-bar-chart-fill"></i> Quick Stats: Last 7 Days</h6>
      </div>

      <div class="card-body">
        <div class="row text-center">
          <div class="col-6 col-lg-3">
            <p class="text-muted fw-bold mb-0">CLICKS (UNIQUES)</p>
            <div class="h5 p-3 bg-light-blue rounded">
              <i class="bi bi-mouse-fill me-2"></i>{{ globalHomeStat.week.uniqueClicks }}
            </div>
          </div>

          <div class="col-6 col-lg-3">
            <p class="text-muted fw-bold mb-0">CONVERSIONS</p>
            <div class="h5 p-3 bg-light-blue rounded">
              <i class="bi bi-check-circle-fill me-2"></i>{{ globalHomeStat.week.conversions }}
            </div>
          </div>

          <div class="col-6 col-lg-3">
            <p class="text-muted fw-bold mb-0">PAYOUT</p>
            <div class="h5 p-3 bg-light-blue rounded">
              <i class="bi bi-cash-stack me-2"></i>{{ globalHomeStat.week.revenue | money }}
            </div>
          </div>

          <div class="col-6 col-lg-3">
            <p class="text-muted fw-bold mb-0">PAYOUT ({{ currentYear }} YTD)</p>
            <div class="h5 p-3 bg-light-blue rounded">
              <i class="bi bi-bar-chart-fill me-2"></i>{{ globalHomeStat.ytd.revenue | money }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-xxl-6">
    <div class="card shadow border-0 h-100">
      <div class="card-header d-flex align-items-center justify-content-between"><h6 class="card-title mb-0"><i
        class="bi bi-megaphone-fill"></i> What's New</h6>
        <!-- Boutons carousel mobile -->
        <div *ngIf="mobileNews.length > 1" class="d-flex d-lg-none align-items-center">
          <button class="carousel-control-prev text-secondary me-2" type="button" data-bs-target="#news-carousel-mobile"
                  data-bs-slide="prev">Previous
          </button>
          <button class="carousel-control-next text-secondary" type="button" data-bs-target="#news-carousel-mobile"
                  data-bs-slide="next">Next
          </button>
        </div>

        <!-- Boutons carousel desktop -->
        <div *ngIf="desktopNews.length > 3" class="d-none d-lg-flex align-items-center">
          <button class="carousel-control-prev text-secondary me-2" type="button" data-bs-target="#news-carousel"
                  data-bs-slide="prev">Previous
          </button>
          <button class="carousel-control-next text-secondary" type="button" data-bs-target="#news-carousel"
                  data-bs-slide="next">Next
          </button>
        </div>
      </div>

      <div class="card-body">
        <!-- Carousel mobile :1 news par slide -->
        <div id="news-carousel-mobile" class="carousel slide d-block d-lg-none" data-bs-ride="carousel">
          <div class="carousel-inner">
            <div *ngFor="let singleNews of mobileNews;let i = index" [class.active]="i === 0" class="carousel-item">
              <div class="news-item align-items-center">
                <img [src]="imageService.getImageUrl(singleNews.image)" class="img-fluid rounded me-3" alt="News Image">
                <div>
                  <p class="text-muted mb-1"><small>📅 {{ singleNews.publishedAt | date:'dd MMM yyyy' }}</small></p>
                  <h6 class="mb-0">{{ singleNews.title }}</h6>
                  <p class="text-muted mb-2">{{ singleNews.excerpt }}</p>
                  <button (click)="openNews(singleNews)" class="btn btn-primary btn-sm fw-bold">Learn more...</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Carousel desktop : 3 news par slide -->
        <div id="news-carousel" class="carousel slide d-none d-lg-block" data-bs-ride="carousel">
          <div class="carousel-inner">
            <div *ngFor="let newsGroup of desktopNews;let i = index" [class.active]="i === 0" class="carousel-item">
              <div *ngFor="let singleNews of newsGroup" class="news-item d-flex align-items-center mb-3">
                <img [src]="imageService.getImageUrl(singleNews.image)" class="img-fluid rounded me-3" alt="News Image">
                <div>
                  <p class="text-muted mb-1"><small>📅 {{ singleNews.publishedAt | date:'dd MMM yyyy' }}</small></p>
                  <h6 class="mb-0">{{ singleNews.title }}</h6>
                  <p class="text-muted mb-2">{{ singleNews.excerpt }}</p>
                  <button (click)="openNews(singleNews)" class="btn btn-primary btn-sm fw-bold">Learn more...</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-xxl-6">
    <div class="card shadow border-0 h-100">
      <div class="card-header">
        <h6 class="card-title mb-0"><i class="bi bi-speedometer2"></i> Global Performance</h6>
      </div>

      <div class="card-body">
        <div class="row mb-3">
          <div class="col-6">
            <div class="bg-light-blue p-3 rounded mb-2">
              <h5 class="mb-0">
                <i class="bi bi-cash-coin me-2"></i>{{ globalHomeStat.mtd.revenue | money }}<strong class="ms-2">MTD</strong></h5>
            </div>
          </div>
          <div class="col-6">
            <div class="bg-light-blue p-3 rounded mb-2">
              <h5 class="mb-0">
                <i class="bi bi-cash-coin me-2"></i>{{ globalHomeStat.ytd.revenue | money }}<strong class="ms-2">YTD</strong>
              </h5>
            </div>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table table-striped table-hover mb-0">
            <thead class="table-light">
            <tr>
              <th>Timeframe</th>
              <th>Clics</th>
              <th>Uniques</th>
              <th>Conversions</th>
              <th>CR (%)</th>
              <th>EPC</th>
              <th>Revenue</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Today - {{ getTodayDate() | date : 'dd/MM/yyyy' }}</td>
              <td>{{ globalHomeStat.today.clicks }}</td>
              <td>{{ globalHomeStat.today.uniqueClicks }}</td>
              <td>{{ globalHomeStat.today.conversions }}</td>
              <td>{{ globalHomeStat.today.conversionRate | percent }}</td>
              <td>{{ globalHomeStat.today.epc | money }}</td>
              <td>{{ globalHomeStat.today.revenue | money }}</td>
            </tr>
            <tr>
              <td>WTD</td>
              <td>{{ globalHomeStat.wtd.clicks }}</td>
              <td>{{ globalHomeStat.wtd.uniqueClicks }}</td>
              <td>{{ globalHomeStat.wtd.conversions }}</td>
              <td>{{ globalHomeStat.wtd.conversionRate | percent }}</td>
              <td>{{ globalHomeStat.wtd.epc | money }}</td>
              <td>{{ globalHomeStat.wtd.revenue | money }}</td>
            </tr>
            <tr>
              <td>7-Day</td>
              <td>{{ globalHomeStat.week.clicks }}</td>
              <td>{{ globalHomeStat.week.uniqueClicks }}</td>
              <td>{{ globalHomeStat.week.conversions }}</td>
              <td>{{ globalHomeStat.week.conversionRate | percent }}</td>
              <td>{{ globalHomeStat.week.epc | money }}</td>
              <td>{{ globalHomeStat.week.revenue | money }}</td>
            </tr>
            <tr>
              <td>MTD</td>
              <td>{{ globalHomeStat.mtd.clicks }}</td>
              <td>{{ globalHomeStat.mtd.uniqueClicks }}</td>
              <td>{{ globalHomeStat.mtd.conversions }}</td>
              <td>{{ globalHomeStat.mtd.conversionRate | percent }}</td>
              <td>{{ globalHomeStat.mtd.epc | money }}</td>
              <td>{{ globalHomeStat.mtd.revenue | money }}</td>
            </tr>
            <tr>
              <td>30-Day</td>
              <td>{{ globalHomeStat.month.clicks }}</td>
              <td>{{ globalHomeStat.month.uniqueClicks }}</td>
              <td>{{ globalHomeStat.month.conversions }}</td>
              <td>{{ globalHomeStat.month.conversionRate | percent }}</td>
              <td>{{ globalHomeStat.month.epc | money }}</td>
              <td>{{ globalHomeStat.month.revenue | money }}</td>
            </tr>
            <tr>
              <td>12 Months</td>
              <td>{{ globalHomeStat.year.clicks }}</td>
              <td>{{ globalHomeStat.year.uniqueClicks }}</td>
              <td>{{ globalHomeStat.year.conversions }}</td>
              <td>{{ globalHomeStat.year.conversionRate | percent }}</td>
              <td>{{ globalHomeStat.year.epc | money }}</td>
              <td>{{ globalHomeStat.year.revenue | money }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="col-xxl-6">
    <div class="card shadow border-0 h-100">
      <div class="card-header">
        <h6 class="card-title mb-0"><i class="bi bi-award-fill"></i> Top Offers</h6>
      </div>

      <div class="card-body">
        <form [formGroup]="topOffersFilter">
          <div class="row">
            <div class="col-6">
              <select (change)="fetchTopOffers()" formControlName="country" class="form-select form-select-sm mb-3" id="country">
                <option [ngValue]="null">🌍 All countries</option>

                <option *ngFor="let country of countries" [value]="country.isoCode">{{ country.flagEmoji }} {{ country }}</option>
              </select>
            </div>

            <div class="col-6">
              <select (change)="fetchTopOffers()" formControlName="date" class="form-select form-select-sm mb-3" id="date">
                <option value="today">Today</option>
                <option value="week">Week</option>
                <option value="month">Month</option>
                <option value="year">Year</option>
              </select>
            </div>
          </div>
        </form>

        <div class="table-responsive">
          <table class="table table-hover table-striped">
            <thead class="table-light">
            <tr>
              <th>#</th>
              <th>Offer Name</th>
              <th>Geos</th>
              <th>Payout Mode</th>
              <th>Payout</th>
              <th>EPC</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let topOffer of topOffers; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ topOffer.offer?.name ?? '' }}</td>
              <td>
                <ng-container *ngIf="topOffer.offer">
                  <ng-container *ngIf="!expandedCountries[i]">
                    <span *ngFor="let country of topOffer.offer.countries.slice(0, 5) ?? []">
                      {{ topOffer.offer.getCountryEmoji(country) }}
                    </span>
                    <span *ngIf="topOffer.offer.countries.length > 5" class="text-muted" role="button"
                          (click)="expandedCountries[i] = true">...({{ topOffer.offer.countries.length }})</span>
                  </ng-container>

                  <ng-container *ngIf="expandedCountries[i]">
                    <span *ngFor="let country of topOffer.offer.countries ?? []">
                      {{ topOffer.offer.getCountryEmoji(country) }}
                    </span>
                    <i (click)="expandedCountries[i] = false" class="bi bi-eye-slash-fill ms-1 text-muted" role="button"></i>
                  </ng-container>
                </ng-container>
              </td>
              <td>
                <span *ngIf="topOffer.offer?.conversionType">{{ ('conversionType.' + topOffer.offer?.conversionType) | translate }}</span>
              </td>
              <td>{{ (topOffer.offer?.payout ?? 0) | currency:2:topOffer.offer?.currency?.isoCode }}</td>
              <td>{{ (topOffer.epc ?? 0) | money:2:topOffer.offer?.currency?.isoCode }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

</div>
